// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__y4dN1","title":"AfterBackImages_title__Svhr5","images":"AfterBackImages_images__1VdfX"};